import { render, staticRenderFns } from "./OrderPopup.vue?vue&type=template&id=21b81c54&scoped=true&"
import script from "./OrderPopup.vue?vue&type=script&lang=js&"
export * from "./OrderPopup.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/popup.css?vue&type=style&index=0&id=21b81c54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b81c54",
  null
  
)

export default component.exports